export default {
  views: {
    invalidUrl: 'The URL is invalid.',
    successToResetPassword: 'Password has been reset successfully.',
    resetPassword: 'Reset Password',
    send: 'Send',
    resetError:
      'The password reset link has expired or the password has already been reset.',
    passwordRules: {
      title: 'Note: Password Rules',
      tips1:
        'Create a password with at least 8 characters combining letters and numbers.'
    },
    enrollOTP: {
      title: 'Register Two-Factor Authentication',
      code: 'Verification Code',
      verify: 'Verify'
    }
  }
};
